import { tns } from 'tiny-slider/src/tiny-slider';
const leftNavSlider = document.querySelectorAll('.component-leftnav-5050__tabs');
//Initiate slider for nav
if (leftNavSlider.length > 0) {
    const slider = tns({
        container: '.component-leftnav-5050__tabs',
        items: 1,
        controls: false,
        nav: false,
        center: false,
        loop: false,
        swipeAngle: false,
        speed: 400,
        autoplay: false,
        autoWidth: true,
        //fixedWidth: 150,
        preventScrollOnTouch: 'auto',
        responsive: {
            768: {
                disable: true
            }
        }
    });
    const sliderNavItems = document.querySelectorAll('.component-leftnav-5050__tabs li');
    const contentContainers = document.querySelectorAll('.component-leftnav-5050__content');
    //Add event listener to each nav item
    sliderNavItems.forEach(function (navItem) {
        navItem.addEventListener('click', function () {
            //Get the index value of the clicked nav item  
            let navItemIndex = Array.from(navItem.parentNode.children).indexOf(navItem);
            //Remove the active class on the content div
            contentContainers.forEach(function (content, index) {
                content.classList.remove('component-leftnav-5050__content--active');
            });
            //Add the active class to the content div equal to the index value of the clicked nav item
            if (contentContainers[navItemIndex]) {
                contentContainers[navItemIndex].classList.add('component-leftnav-5050__content--active');
            }

            //Remove active class from all nav items    
            sliderNavItems.forEach(function (item, index) {
                item.classList.remove('active');
            });
            //Add active to clicked nav item
            this.classList.add('active');
        });
    });
}
